import { useQueryClient } from '@tanstack/react-query';
import { useState, type FormEvent, type ReactNode } from 'react';

import { Button, Field, Input } from '../components/atoms';
import { ErrorBlock } from '../components/molecules';
import { signIn } from '../lib/auth';

export function LoginPage(): ReactNode {
  const client = useQueryClient();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function onSubmit(event: FormEvent): Promise<void> {
    event.preventDefault();
    setPending(true);
    setError(null);
    try {
      await signIn(email, password);
      await client.invalidateQueries();
      window.location.assign('/');
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'Falha no login.');
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="flex h-full items-center justify-center p-6">
      <form
        className="card w-full max-w-sm space-y-1 shadow-neon"
        onSubmit={(event) => {
          void onSubmit(event);
        }}
      >
        <div className="mb-4 flex items-center gap-3">
          <img src="/logo-visualitics.png" alt="Visualitics" className="h-9 w-auto" />
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-neon">Visualitics</p>
            <h1 className="text-lg font-semibold text-content">Toolkit</h1>
          </div>
        </div>
        <p className="mb-4 text-sm text-muted">
          Ferramenta interna de manutenção. O cadastro é feito pelo bootstrap do servidor.
        </p>

        <Field label="E-mail" htmlFor="email">
          <Input
            id="email"
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </Field>

        <Field label="Senha" htmlFor="password">
          <Input
            id="password"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </Field>

        {error && <ErrorBlock message={error} />}

        <Button type="submit" variant="primary" className="mt-2 w-full" loading={pending}>
          Entrar
        </Button>
      </form>
    </div>
  );
}
